export enum MappingContextType {
	Service,
	Charge,
	FilterRow
}
